import { websiteSagasWatch } from "./website/WebsiteSagas";
import dashboardSagasWatch from "./dashboard/DashboardSagas";
import { fork, all } from "redux-saga/effects";
export default function* watchAll() {
  yield all([fork(websiteSagasWatch), fork(dashboardSagasWatch)]);
}
